import * as React from 'react';

import * as styles from './ReviewsFooter.css';

export const ReviewsFooter = (props: React.PropsWithChildren<{}>) => {
  return <div className={styles['footer']}>{props.children}</div>;
};
